import React from 'react';
import { Icon } from '@blueprintjs/core';
import Dropzone from 'react-dropzone';
import styled from 'styled-components';
import colors from 'utils/colors';

const rejectedState = {
  borderStyle: 'solid',
  borderColor: '#c66',
  backgroundColor: '#eee',
};
const disabledState = {
  opacity: 0.5,
  cursor: 'no-drop',
};
const activeState = {
  borderStyle: 'solid',
  borderColor: '#6c6',
  backgroundColor: '#eee',
};

const acceptState = {
  borderStyle: 'solid',
  borderColor: '#6c6',
  backgroundColor: '#eee',
};
const defaultState = {
  width: '100%',
  minHeight: 50,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: 20,
  cursor: 'pointer',
};

const AddAttachmentsSection = ({ handleOnDrop }) => (
  <Container>
    <Dropzone
      onDrop={handleOnDrop}
      style={defaultState}
      activeStyle={activeState}
      disabledStyle={disabledState}
      rejectStyle={rejectedState}
      acceptStyle={acceptState}
    >
      {({ getRootProps, getInputProps }) => (
        <section>
          <DropzoneWrapper {...getRootProps()}>
            <input title="fileDropzone" {...getInputProps()} />
            <Icon icon="folder-shared-open" color={colors.lightGray} />
            <TextWrapper>Drop files to attach or</TextWrapper>
            <BrowseLink>browse.</BrowseLink>
          </DropzoneWrapper>
        </section>
      )}
    </Dropzone>
    <p>
      Accepted file types are: .pdf, .txt, .doc, .docx, .odt, .xls, .xlsx, .ods,
      .ppt, .pptx, .html, .htm, .msg
    </p>
  </Container>
);

const Container = styled.div`
  width: 17rem;
  margin: 2rem;
`;
const DropzoneWrapper = styled.div`
  border: 2px dashed #ccc;
  border-radius: 5px;
  padding: 2rem;
  height: 100%;
  &:hover {
    cursor: pointer;
    border-color: ${colors.primary};
  }
`;
const BrowseLink = styled.span`
  text-decoration: underline;
  color: ${colors.primary};
`;

const TextWrapper = styled.span`
  margin: 0 3px;
`;

export default AddAttachmentsSection;
